import { useEffect } from "react";
import { useImmer } from "use-immer";

import {
  GetSchedulesByExperienceIdResponseBodyType,
  ScheduleDto,
} from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { scheduleKeys } from "../queryKeys";

const getAllSchedules = async () => {
  const resp = await api.get<GetSchedulesByExperienceIdResponseBodyType>(
    `/v2/schedules/experiences`
  );
  return resp.data;
};

export const useGetAndSetAllSchedules = () => {
  const [schedules, setSchedules] = useImmer<ScheduleDto[]>([]);

  const schedulesQuery = useQuery<
    GetSchedulesByExperienceIdResponseBodyType,
    Error
  >({
    queryKey: scheduleKeys.all,
    queryFn: async () => getAllSchedules(),
  });

  useEffect(() => {
    if (schedulesQuery.isSuccess && schedulesQuery.data?.schedules) {
      setSchedules(schedulesQuery.data.schedules);
    }
  }, [schedulesQuery.isSuccess, schedulesQuery.data]);

  return { isLoading: schedulesQuery.isLoading, schedules };
};
